module.exports = __webpack_public_path__ + "img/09-min.66784162.jpg";